/**
 * Runtime environment configuration.
 *
 * In dev these are read from `.env.local`; in prod they're injected by the
 * Cloudflare Pages build via wrangler.
 */
export const env = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL ?? '',
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY ?? '',
  /**
   * Base URL for the social-generator backend. In dev set to "/api" and let
   * the Vite proxy forward to http://localhost:3007 (see vite.config.ts).
   * In prod set to the deployed Cloud Run URL.
   */
  socialGeneratorApiBase:
    import.meta.env.VITE_SOCIAL_GENERATOR_API_BASE ?? '/api',
};
